<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="bg-white p-5 shadow m-2">
      <form id="basic" @submit.prevent="">
        <div class="grid grid-cols-2 items-center mt-5">
          <div>
            <div class="text-3xl font-bold inline-block">
              <font-awesome-icon
              class="reaction"
              size="md"
              :icon="['fas', 'link']"
              @click="Gotoprofile()"
            />
            Configure Profile Page
            </div>
          </div>
          <div class="text-right">
            <button :disabled="!verified" @click="save" class="btn btn-primary text-lg ml-3">
              Save
            </button>
          </div>
        </div>
        <div class="mt-4">
          <div>
            <div class="text-xl text-gray-800 inline-block">Bio</div>
            <input
              type="text"
              placeholder="Bio"
              class="input input-bordered w-full mb-2 mt-2"
              name="usersignature"
              v-model="usersignature"
            />
          </div>
          <!-- <div class="grid grid-cols-2 justify-center mt-4"> -->
          <div class="flex justify-evenly">
            <div class="mt-4 flex flex-col items-center">
              <div class="text-xl text-gray-800 mb-3 inline-block">
                Main Header Background color
              </div>
              <chrome-picker v-model="mainbackcolor" />
            </div>
            <div class="mt-4 flex flex-col items-center">
              <div class="text-xl text-gray-800 mb-2 inline-block">
                Course Header Background color
              </div>
              <chrome-picker v-model="coursebackcolor" />
            </div>
          </div>
          <div class="mt-4">
            <div class="text-xl text-gray-800 inline-block">Custom Domain</div>
            <div class="grid grid-cols-2 items-center mt-5">
            <input
              type="text"
              placeholder="Domain Name"
              class="input input-bordered w-full mb-2 mt-2"
              name="Domain Name"
              v-model="domain"
              @input="verified = olddomain === domain"
            />
            <button @click="verifyDomain" v-if="!verified" class="btn btn-primary w-32 text-lg ml-3">
              Verify
            </button>
            <button v-if="verified" disabled="true" class="btn btn-primary w-32 text-lg ml-3">
              verified
            </button>
            </div>
            <div class="text-md text-gray-600 inline-block">
              Note: Add 'site.implicit.io' as cname in your domain and click on verify. Once its verified you can save and access your courses on your custom domain.
            </div>
          </div>
          <div class="mt-4 mb-4">
            <div class="flex items-center justify-between">
              <div class="form-control">
                <label
                  class="cursor-pointer label justify-start"
                  style="width: fit-content"
                >
                  <input
                    type="checkbox"
                    checked="checked"
                    class="checkbox checkbox-primary"
                    v-model="showHeaderMenu"
                    @click="toggleshowHeaderMenu()"
                  />
                  <span class="text-xl text-gray-800 inline-block ml-3"
                    >Header Menu Options</span
                  >
                </label>
              </div>
              <div v-if="showHeaderMenu">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addnew = true"
                >
                  <font-awesome-icon
                    class="mr-3"
                    size="lg"
                    :icon="['fas', 'plus']"
                  />
                  Add New
                </button>
              </div>
            </div>
            <input
              v-if="addnew"
              type="text"
              placeholder="Menu Title"
              class="input input-bordered w-full mb-2 mt-2"
              v-model="headerTitle"
            />
            <input
              v-if="addnew"
              type="text"
              placeholder="Link for Menu"
              class="input input-bordered w-full mb-2 mt-2"
              v-model="headerLink"
            />
            <button
              v-if="addnew"
              :disabled="headerTitle.trim() && headerLink.trim() === ''"
              type="submit"
              class="btn btn-primary text-lg ml-3 mt-2"
              @click="saveHeaderMenuOption"
            >
              Save
            </button>
            <button
              v-if="addnew"
              type="button"
              class="btn btn-primary text-lg ml-3 mt-2"
              @click="CancelAddNew"
            >
              Cancel
            </button>
            <div v-if="showHeaderMenu && HeaderMenuOptions.length > 0">
              <div
                v-for="(menu, index) in HeaderMenuOptions"
                :key="index"
                class="grid grid-cols-2 items-center bg-white p-6 mb-1"
              >
                <div>
                  <h3 class="font-medium text-base inline-block mb-0 ml-3 mr-8">
                    {{ index + 1 }}
                  </h3>
                  <h3 class="font-medium text-base inline-block mb-0">
                    {{ menu.title }}
                  </h3>
                </div>
                <div class="text-right">
                  <div class="tooltip" data-tip="Delete Lesson">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['far', 'trash-alt']"
                      @click="deleteHeaderMenuOption(menu)"
                    />
                  </div>
                  <div class="tooltip" data-tip="Move Up">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['fas', 'arrow-up']"
                      @click="
                        changeOrderHeader(menu, HeaderMenuOptions[index - 1])
                      "
                    />
                  </div>
                  <div class="tooltip" data-tip="Move Down">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['fas', 'arrow-down']"
                      @click="
                        changeOrderHeader(HeaderMenuOptions[index + 1], menu)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 mb-4">
            <div class="flex items-center justify-between">
              <div class="form-control">
                <label
                  class="cursor-pointer label justify-start"
                  style="width: fit-content"
                >
                  <input
                    type="checkbox"
                    checked="checked"
                    class="checkbox checkbox-primary"
                    v-model="showLeftMenu"
                    @click="toggleShowLeftMenu"
                  />
                  <span class="text-xl text-gray-800 inline-block ml-3">
                    Left Menu Options</span
                  >
                </label>
              </div>
              <div v-if="showLeftMenu">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addNewLeft = true"
                >
                  <font-awesome-icon
                    class="mr-3"
                    size="lg"
                    :icon="['fas', 'plus']"
                  />
                  Add New
                </button>
              </div>
            </div>
            <input
              v-if="addNewLeft"
              type="text"
              placeholder="Menu Title"
              class="input input-bordered w-full mb-2 mt-2"
              v-model="leftTitle"
            />
            <input
              v-if="addNewLeft"
              type="text"
              placeholder="Link for Menu"
              class="input input-bordered w-full mb-2 mt-2"
              v-model="leftLink"
            />
            <button
              v-if="addNewLeft"
              :disabled="leftTitle.trim() && leftLink.trim() === ''"
              type="submit"
              class="btn btn-primary text-lg ml-3 mt-2"
              @click="saveLeftMenuOption"
            >
              Save
            </button>
            <button
              v-if="addNewLeft"
              type="button"
              class="btn btn-primary text-lg ml-3 mt-2"
              @click="CancelAddNewLeft"
            >
              Cancel
            </button>
            <div v-if="showLeftMenu && LeftMenuOptions.length > 0">
              <div
                v-for="(menu, index) in LeftMenuOptions"
                :key="index"
                class="grid grid-cols-2 items-center bg-white p-6 mb-1"
              >
                <div>
                  <h3 class="font-medium text-base inline-block mb-0 ml-3 mr-8">
                    {{ index + 1 }}
                  </h3>
                  <h3 class="font-medium text-base inline-block mb-0">
                    {{ menu.title }}
                  </h3>
                </div>
                <div class="text-right">
                  <div class="tooltip" data-tip="Delete Lesson">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['far', 'trash-alt']"
                      @click="deleteLeftMenuOption(menu)"
                    />
                  </div>
                  <div class="tooltip" data-tip="Move Up">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['fas', 'arrow-up']"
                      @click="changeOrderLeft(menu, LeftMenuOptions[index - 1])"
                    />
                  </div>
                  <div class="tooltip" data-tip="Move Down">
                    <font-awesome-icon
                      class="reaction text-gray-600 ml-4"
                      size="lg"
                      :icon="['fas', 'arrow-down']"
                      @click="changeOrderLeft(LeftMenuOptions[index + 1], menu)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';
import userInfo from '@/services/userInfo';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'configure',
  layout: 'admin',
  components: {
    'chrome-picker': Chrome,
  },
  data() {
    return {
      userdata: [],
      usersignature: '',
      verified: true,
      domain: '',
      olddomain: '',
      coursetextcolor: '',
      coursebackcolor: { hex: '#194d33' },
      maintextcolor: '',
      mainbackcolor: { hex: '#194d33' },
      showHeaderMenu: false,
      showLeftMenu: false,
      addnew: false,
      addNewLeft: false,
      headerTitle: '',
      headerLink: '',
      leftTitle: '',
      leftLink: '',
      HeaderMenuOptions: [],
      LeftMenuOptions: [],
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    store.commit('toggleLoading', true);
    this.userdata = await userInfo.getUserInfo(this.user.uid);
    this.usersignature = this.userdata.user.userSignature;
    this.mainbackcolor = this.userdata.user.mainHeaderBg;
    this.maintextcolor = this.userdata.user.mainHeaderTextColor;
    this.coursebackcolor = this.userdata.user.courseHeaderBg;
    this.coursetextcolor = this.userdata.user.courseHeaderTextColor;
    this.domain = this.userdata.user.customDomain;
    this.olddomain = this.userdata.user.customDomain;
    this.showHeaderMenu = this.userdata.user.showHeaderMenu;
    this.HeaderMenuOptions = this.userdata.user.HeaderMenuOptions;
    this.showLeftMenu = this.userdata.user.showLeftMenu;
    this.LeftMenuOptions = this.userdata.user.LeftMenuOptions;
    console.log(this.HeaderMenuOptions, this.showHeaderMenu);
    console.log(this.LeftMenuOptions, this.showLeftMenu);
    store.commit('toggleLoading', false);
  },
  methods: {
    async verifyDomain() {
      store.commit('toggleLoading', true);
      await userInfo
        .verifydomain({
          customDomain: this.domain,
        }).catch((err) => {
          console.log(err);
          utils.setStatusMsg(
            this,
            'Domain is not verified, Please check your domain settings and try again',
          );
          store.commit('toggleLoading', false);
        })
        .then((res) => {
          const cname = res.data.data.data[0].data.CNAME;
          store.commit('toggleLoading', false);
          if (cname && cname.length === 1 && cname[0] === 'site.implicit.io') {
            this.verified = true;
          } else {
            utils.setStatusMsg(
              this,
              'Domain is not verified, Please check your domain settings and try again',
            );
          }
        });
    },
    Gotoprofile() {
      window.location.href = `https://discover.implicit.io/u/${this.userdata.user.acctUsername}`;
    },
    async save() {
      console.log(this.mainbackcolor.hex);
      store.commit('toggleLoading', true);
      await userInfo
        .updateconfiguration({
          userSignature: this.usersignature,
          mainHeaderBg: this.mainbackcolor.hex,
          mainHeaderTextColor: this.maintextcolor,
          courseHeaderBg: this.coursebackcolor.hex,
          courseHeaderTextColor: this.coursetextcolor,
          customDomain: this.domain,
          showHeaderMenu: this.showHeaderMenu,
          HeaderMenuOptions: this.HeaderMenuOptions,
          showLeftMenu: this.showLeftMenu,
          LeftMenuOptions: this.LeftMenuOptions,
        })
        .catch((error) => {
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
      store.commit('toggleLoading', false);
    },
    async toggleshowHeaderMenu() {
      this.showHeaderMenu = !this.showHeaderMenu;
      this.addnew = false;
      this.headerTitle = '';
      this.headerLink = '';
    },
    async toggleShowLeftMenu() {
      this.showLeftMenu = !this.showLeftMenu;
      this.addNewLeft = false;
      this.leftTitle = '';
      this.leftLink = '';
    },
    async CancelAddNew() {
      this.addnew = false;
      this.headerTitle = '';
      this.headerLink = '';
    },
    async CancelAddNewLeft() {
      this.addNewLeft = false;
      this.leftTitle = '';
      this.leftLink = '';
    },
    async saveHeaderMenuOption() {
      store.commit('toggleLoading', true);
      const option = {
        title: this.headerTitle,
        link: this.headerLink,
        display_order: this.HeaderMenuOptions.length,
      };
      this.HeaderMenuOptions.push(option);
      this.addnew = false;
      this.headerTitle = '';
      this.headerLink = '';
      store.commit('toggleLoading', false);
    },
    async saveLeftMenuOption() {
      store.commit('toggleLoading', true);
      const option = {
        title: this.leftTitle,
        link: this.leftLink,
        display_order: this.LeftMenuOptions.length,
      };
      this.LeftMenuOptions.push(option);
      this.addNewLeft = false;
      this.leftTitle = '';
      this.leftLink = '';
      store.commit('toggleLoading', false);
    },
    async changeOrderHeader(menu, menu2) {
      if (!menu) {
        utils.setStatusMsg(this, 'Header Menu option is already on last');
      } else if (!menu2) {
        utils.setStatusMsg(this, 'Header Menu option is already on first');
      } else {
        store.commit('toggleLoading', true);
        const index = this.HeaderMenuOptions.indexOf(menu);
        const index2 = this.HeaderMenuOptions.indexOf(menu2);
        this.HeaderMenuOptions.splice(index, 1);
        this.HeaderMenuOptions.splice(index2, 0, menu);
        console.log(this.HeaderMenuOptions.map((x) => x.display_order));
        store.commit('toggleLoading', false);
      }
    },
    async changeOrderLeft(menu, menu2) {
      if (!menu) {
        utils.setStatusMsg(this, 'Left Menu option is already on last');
      } else if (!menu2) {
        utils.setStatusMsg(this, 'Left Menu option is already on first');
      } else {
        store.commit('toggleLoading', true);
        const index = this.LeftMenuOptions.indexOf(menu);
        const index2 = this.LeftMenuOptions.indexOf(menu2);
        this.LeftMenuOptions.splice(index, 1);
        this.LeftMenuOptions.splice(index2, 0, menu);
        console.log(this.LeftMenuOptions.map((x) => x.display_order));
        store.commit('toggleLoading', false);
      }
    },
    async deleteHeaderMenuOption(menu) {
      store.commit('toggleLoading', true);
      const index = this.HeaderMenuOptions.indexOf(menu);
      // then remove it from the array and update the display order
      this.HeaderMenuOptions.splice(index, 1);
      this.HeaderMenuOptions.map((x, i) => {
        const option = {
          title: x.title,
          link: x.link,
          display_order: i,
        };
        this.HeaderMenuOptions[i] = option;
        console.log(this.HeaderMenuOptions);
        return true;
      });
      store.commit('toggleLoading', false);
    },
    async deleteLeftMenuOption(menu) {
      store.commit('toggleLoading', true);
      const index = this.LeftMenuOptions.indexOf(menu);
      // then remove it from the array and update the display order
      this.LeftMenuOptions.splice(index, 1);
      this.LeftMenuOptions.map((x, i) => {
        const option = {
          title: x.title,
          link: x.link,
          display_order: i,
        };
        this.LeftMenuOptions[i] = option;
        console.log(this.LeftMenuOptions);
        return true;
      });
      store.commit('toggleLoading', false);
    },
  },
};
</script>
